// Namespace "admin": administration pages (users, roles, work schedules, team, teams)
const admin = {
  'admin.common.save': 'Save',
  'admin.common.cancel': 'Cancel',
  'admin.common.edit': 'Edit',
  'admin.common.delete': 'Delete',
  'admin.common.error': 'Error',
  'admin.common.none': '–',

  'admin.users.title': 'User management',
  'admin.users.new': 'New user',
  'admin.users.edit': 'Edit user',
  'admin.users.personnelNumber': 'Personnel number *',
  'admin.users.password': 'Password',
  'admin.users.passwordKeep': '(empty = unchanged)',
  'admin.users.firstName': 'First name *',
  'admin.users.lastName': 'Last name *',
  'admin.users.email': 'Email',
  'admin.users.role': 'Role',
  'admin.users.noRole': '– No role –',
  'admin.users.supervisor': 'Supervisor',
  'admin.users.noSupervisor': '– No supervisor –',
  'admin.users.weeklyHours': 'Weekly working hours',
  'admin.users.vacationDays': 'Vacation days per year',
  'admin.users.entryDate': 'Entry date',
  'admin.users.col.nr': 'No.',
  'admin.users.col.name': 'Name',
  'admin.users.col.email': 'Email',
  'admin.users.col.role': 'Role',
  'admin.users.col.supervisor': 'Supervisor',
  'admin.users.col.status': 'Status',
  'admin.users.col.created': 'Created',
  'admin.users.col.actions': 'Actions',
  'admin.users.active': 'Active',
  'admin.users.inactive': 'Inactive',
  'admin.users.deactivate': 'Deactivate',
  'admin.users.activate': 'Activate',
  'admin.users.confirmDelete': 'Really delete this user?',

  'admin.roles.title': 'Roles & permissions',
  'admin.roles.roles': 'Roles',
  'admin.roles.new': 'New role',
  'admin.roles.edit': 'Edit role',
  'admin.roles.name': 'Name *',
  'admin.roles.description': 'Description',
  'admin.roles.permissions': 'Permissions:',
  'admin.roles.confirmDelete': 'Really delete this role?',
  'admin.roles.permissionsTitle': 'Permissions',
  'admin.roles.newPermission': 'New permission',
  'admin.roles.code': 'Code (unique) *',
  'admin.roles.create': 'Create',
  'admin.roles.confirmDeletePermission': 'Really delete this permission?',

  'admin.schedules.title': 'Work schedules',
  'admin.schedules.new': 'New schedule',
  'admin.schedules.edit': 'Edit schedule',
  'admin.schedules.newTitle': 'New work schedule',
  'admin.schedules.name': 'Name *',
  'admin.schedules.type': 'Type',
  'admin.schedules.typeFixedLong': 'Fixed working hours',
  'admin.schedules.typeFlex': 'Flextime',
  'admin.schedules.typeFixedShort': 'Fixed time',
  'admin.schedules.employee': 'Employee (empty = default)',
  'admin.schedules.defaultAll': 'Default (all)',
  'admin.schedules.workStart': 'Start of work',
  'admin.schedules.workEnd': 'End of work',
  'admin.schedules.dailyHours': 'Daily target hours',
  'admin.schedules.dayHoursTitle': 'Target hours per weekday (optional)',
  'admin.schedules.dayHoursHint': 'Empty = daily target hours × working days. 0 = day off.',
  'admin.schedules.weekTotal': 'Weekly target: {hours}h',
  'admin.schedules.dayHoursLabel': 'Weekdays:',
  'admin.schedules.daysPerWeek': 'Working days / week',
  'admin.schedules.autoBreakAfter': 'Auto break after (hours)',
  'admin.schedules.autoBreakAfterPlaceholder': 'e.g. 6',
  'admin.schedules.autoBreakDuration': 'Auto break duration (minutes)',
  'admin.schedules.autoBreakDurationPlaceholder': 'e.g. 30',
  'admin.schedules.setDefault': 'Set as default',
  'admin.schedules.default': 'Default',
  'admin.schedules.typeLabel': 'Type:',
  'admin.schedules.employeeLabel': 'Employee:',
  'admin.schedules.targetLabel': 'Target time:',
  'admin.schedules.targetValue': '{hours}h / day · {days} days/wk.',
  'admin.schedules.timesLabel': 'Times:',
  'admin.schedules.autoBreakLabel': 'Auto break:',
  'admin.schedules.autoBreakValue': 'after {hours}h → {minutes} min',
  'admin.schedules.empty': 'No work schedules available.',
  'admin.schedules.confirmDelete': 'Delete work schedule?',
  'admin.schedules.unknownUser': 'User #{id}',

  'admin.team.title': 'Team overview',
  'admin.team.refreshHint': 'Refreshed every minute',
  'admin.team.total': 'Total employees',
  'admin.team.checkedIn': 'Clocked in',
  'admin.team.notPresent': 'Not present',
  'admin.team.filterAll': 'All',
  'admin.team.filterIn': 'Present',
  'admin.team.filterOut': 'Absent',
  'admin.team.homeOffice': 'Home office',
  'admin.team.office': 'Office',
  'admin.team.absent': 'Absent',
  'admin.team.pdfTitle': 'Download monthly report {month} {year}',
  'admin.team.empty': 'No employees found.',
  'admin.team.reportFile': 'MonthlyReport',

  'admin.teams.title': 'Teams',
  'admin.teams.newTitle': 'Create new team',
  'admin.teams.name': 'Team name',
  'admin.teams.description': 'Description (optional)',
  'admin.teams.substituteRequired': 'Substitute required for vacation requests',
  'admin.teams.substituteRequiredHint': 'Members must choose a substitute from the team when requesting vacation.',
  'admin.teams.create': 'Create',
  'admin.teams.empty': 'No teams available',
  'admin.teams.noMembers': 'No members',
  'admin.teams.deleteTitle': 'Delete team',
  'admin.teams.removeTitle': 'Remove from team',
  'admin.teams.addEmployee': 'Add employee…',
  'admin.teams.add': 'Add',
  'admin.teams.confirmDelete': 'Really delete team "{name}"?',
  'admin.teams.actionFailed': 'Action failed',

  'admin.overview.title': 'Administration',
  'admin.overview.subtitle': 'Central overview of all administration areas',
  'admin.overview.open': 'Open',
  'admin.overview.users.title': 'Users',
  'admin.overview.users.desc': 'Create and manage user accounts',
  'admin.overview.roles.title': 'Roles',
  'admin.overview.roles.desc': 'Define roles and permissions',
  'admin.overview.schedules.title': 'Work schedules',
  'admin.overview.schedules.desc': 'Maintain work schedules',
  'admin.overview.team.title': 'Team',
  'admin.overview.team.desc': 'View team times and status',
  'admin.overview.teams.title': 'Teams',
  'admin.overview.teams.desc': 'Create teams and assign members',
  'admin.userDetail.title': 'User details',
  'admin.userDetail.open': 'Details',
  'admin.userDetail.back': 'Back to user list',
  'admin.userDetail.notFound': 'User could not be loaded',
  'admin.userDetail.master': 'Master data',
  'admin.userDetail.year': 'Year',
  'admin.userDetail.times': 'Time entries',
  'admin.userDetail.timesTotal': 'Total: {hours} h',
  'admin.userDetail.noTimes': 'No time entries',
  'admin.userDetail.col.date': 'Date',
  'admin.userDetail.col.checkIn': 'Check-in',
  'admin.userDetail.col.checkOut': 'Check-out',
  'admin.userDetail.col.break': 'Break (min.)',
  'admin.userDetail.col.worked': 'Worked',
  'admin.userDetail.vacation': 'Vacation',
  'admin.userDetail.noVacation': 'No vacation requests',
  'admin.userDetail.vacationStatus.PENDING': 'Pending',
  'admin.userDetail.vacationStatus.APPROVED': 'Approved',
  'admin.userDetail.vacationStatus.REJECTED': 'Rejected',
  'admin.userDetail.absences': 'Absences',
  'admin.userDetail.absencesAdd': 'Add absence',
  'admin.userDetail.absencesEdit': 'Edit absence',
  'admin.userDetail.noAbsences': 'No absences',
  'admin.userDetail.noAbsencePermission': 'The "manage_absences" permission is required for absences.',
};

export default admin;

